import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function JoinCreator() {
  const { user } = useAuth();
  useEffect(() => {
    const p = new URLSearchParams(window.location.search);
    localStorage.setItem("velluto_src", JSON.stringify({
      source: (p.get("utm_source") || "creator-ad").slice(0, 80), medium: (p.get("utm_medium") || "").slice(0, 80),
      campaign: (p.get("utm_campaign") || "").slice(0, 120), landing: "/join", intent: "creator",
    }));
    sessionStorage.setItem("velluto_next", "/apply");
    localStorage.setItem("velluto_after_confirm", "/apply");
  }, []);
  if (user === null) return <div className="pt-32 text-center text-text-muted">Loading…</div>;
  return <Navigate to={user ? "/apply" : "/auth?mode=register&creator=1"} replace />;
}
